import { ImageData as data, getBitstrayData } from '@bitstrays/assets';
import { buildSVG } from '@bitstrays/sdk';
import { IBitstraySeed, useBitstraySeed } from '../../wrappers/bitstrayToken';
import { useBitstraySeedCandiate } from '../../wrappers/bitstraysSeeder';
import Bitstray from '../Bitstray';
import { Link } from 'react-router-dom';
import classes from './StandaloneBitstray.module.css';

interface StandaloneBitstrayProps {
  bitstrayId: bigint;
}

interface StandaloneBitstrayWithSeedProps {
  bitstrayId: bigint;
  onLoadSeed?: (seed: IBitstraySeed) => void;
  shouldLinkToProfile: boolean;
}

interface StandaloneCandidateBitstrayWithSeedProps {
  bitstrayId: bigint;
  onLoadSeed?: (seed: IBitstraySeed) => void;
}

const getBitstray = (bitstrayId: bigint, seed: IBitstraySeed) => {
  const id = bitstrayId.toString();
  const name = `Bitstray ${id}`;
  const description = `Bitstray ${id} - 100% onchain art`;
  const { parts, background } = getBitstrayData(seed);
  const image = `data:image/svg+xml;base64,${btoa(buildSVG(parts, data.palette, background))}`;

  return {
    name,
    description,
    image,
  };
};

const StandaloneBitstray: React.FC<StandaloneBitstrayProps> = (props: StandaloneBitstrayProps) => {
  const { bitstrayId } = props;
  const seed = useBitstraySeed(bitstrayId);
  const bitstray = seed && getBitstray(bitstrayId, seed);

  return (
    <Link to={'/bitstray/' + bitstrayId.toString()} className={classes.clickableBitstray}>
      <Bitstray imgPath={bitstray ? bitstray.image : ''} alt={bitstray ? bitstray.description : 'Bitstray'} />
    </Link>
  );
};

export const StandaloneCandidateBitstrayWithSeed: React.FC<StandaloneCandidateBitstrayWithSeedProps> = (
  props: StandaloneCandidateBitstrayWithSeedProps,
) => {
  const { bitstrayId, onLoadSeed } = props;

  const seed = useBitstraySeedCandiate(bitstrayId);

  if (!seed || bitstrayId === undefined || !onLoadSeed) return <Bitstray imgPath="" alt="Bitstray" />;

  onLoadSeed(seed);
  const { image, description } = getBitstray(bitstrayId, seed);

  const bitstray = <Bitstray imgPath={image} alt={description} />;
  return bitstray;
};

export const StandaloneBitstrayWithSeed: React.FC<StandaloneBitstrayWithSeedProps> = (
  props: StandaloneBitstrayWithSeedProps,
) => {
  const { bitstrayId, onLoadSeed, shouldLinkToProfile } = props;

  const seed = useBitstraySeed(bitstrayId);

  if (!seed || bitstrayId === undefined || !onLoadSeed) return <Bitstray imgPath="" alt="Bitstray" />;

  onLoadSeed(seed);
  const { image, description } = getBitstray(bitstrayId, seed);

  const bitstray = <Bitstray imgPath={image} alt={description} />;
  const bitstrayWithLink = (
    <Link to={'/bitstray/' + bitstrayId.toString()} className={classes.clickableBitstray}>
      {bitstray}
    </Link>
  );
  return shouldLinkToProfile ? bitstrayWithLink : bitstray;
};

export default StandaloneBitstray;
